import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PaginationCriteria, PaginatedResult } from 'jul-web-shared-lib';
import { ApiEndpoints } from '../../http/api-endpoints';
import { JulContextLibService } from 'jul-web-shared-lib/src/lib/components/context';

@Injectable({
  providedIn: 'root'
})
export class UserGeneralDataService {

  constructor(private http: HttpClient, private julContextService: JulContextLibService) { }

  getPaginated(criteria: PaginationCriteria<any>): Observable<PaginatedResult<any[]>> {
    this.julContextService.setContextNational();
    let paginatedResult: PaginatedResult<any[]> = new PaginatedResult<any[]>();

    return this.http.post(ApiEndpoints.core.user_general_data.search(), criteria, { observe: 'response' }).pipe(
      map((response: any) => {
        paginatedResult = response.body.data;
        return paginatedResult;
      }
      ));
  }

  getSearchPaginated(criteria: PaginationCriteria<any>): Observable<PaginatedResult<any[]>> {
    this.julContextService.setContextNational();
    let paginatedResult: PaginatedResult<any[]> = new PaginatedResult<any[]>();

    return this.http.post(ApiEndpoints.core.user_general_data.screensearch(), criteria, { observe: 'response' }).pipe(
      map((response: any) => {
        paginatedResult = response.body.data;
        return paginatedResult;
      }
      ));
  }

  getAll(): Observable<any> {
    this.julContextService.setContextNational();
    return this.http.get<any>(ApiEndpoints.core.user_general_data.public()).pipe(
      map((response: any) => <any>response.data)
    );
  }

  get(id: string): Observable<any> {
    this.julContextService.setContextNational();
    return this.http.get<any>(ApiEndpoints.core.user_general_data.get(id)).pipe(
      map((response: any) => <any>response)
    );
  }

  getPhotoRequestAddress(id: string): string {
    this.julContextService.setContextNational();
    return ApiEndpoints.core.user_general_data.getPhoto(id);
  }

  getPhoto(id: string): Observable<any> {
    this.julContextService.setContextNational();
    return this.http.get<any>(ApiEndpoints.core.user_general_data.getPhoto(id));
  }

  create(user: any) {
    this.julContextService.setContextNational();
    return this.http.post(ApiEndpoints.core.user_general_data.post(), user);
  }

  update(user: any) {
    this.julContextService.setContextNational();
    return this.http.put(ApiEndpoints.core.user_general_data.put(), user);
  }

  delete(id: string, version: string) {
    this.julContextService.setContextNational();
    return this.http.delete(ApiEndpoints.core.user_general_data.delete(id, version));
  }

  block(id: string, versionNumber: string) {
    this.julContextService.setContextNational();
    return this.http.post(ApiEndpoints.core.user_general_data.block(id, versionNumber), null);
  }

  activate(id: string, versionNumber: string) {
    this.julContextService.setContextNational();
    return this.http.post(ApiEndpoints.core.user_general_data.activate(id, versionNumber), null);
  }


}

